// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"57":"c1606a66","187":"5480abd7","365":"42fec01c","383":"f5020255","454":"a2df8251","591":"065e2bab","614":"4640cbb8","698":"29f40e1a","900":"adeeed21","944":"f81dfd54"}[chunkId] + ".js";
};